import NavBar from 'common/components/NavBar'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Outlet, useLocation } from 'react-router'
import BoundaryError from 'common/components/BoundaryError'
import { hasPermission } from 'common/utils/HabilitationUtil'

// Layout de la section Instances : NavBar secondaire (Instances / Services) + Outlet.
const InstancesMenuApp = () => {
    const { pathname } = useLocation()
    const user = useSelector(store => store.app.user, shallowEqual)

    const links = [
        { id: 'instances', icon: 'devices', tooltip: 'Instances', url: '/instance' },
        { id: 'services', icon: 'pie_chart', tooltip: 'Services', url: '/service' },
    ].filter(link => hasPermission(user, link.id, 'view'))

    return (
        <>
            <NavBar links={links} />
            <BoundaryError url={pathname}>
                <div style={{ marginLeft: '65px' }}>
                    <Outlet />
                </div>
            </BoundaryError>
        </>
    )
}

export default InstancesMenuApp
